import apiUrls from 'base/api/urls';
import { useListQuery } from 'base/api/hooks';
import { ContentGoal } from 'base/api/types';

export const useContentGoalsList = () => {
  return useListQuery<ContentGoal>(apiUrls.CONTENT_GOALS.LIST);
};
